export default __webpack_public_path__ + "texture/star_colorshift.png";